import { render } from "./WorkInteractions.vue?vue&type=template&id=6542f809&scoped=true"
import script from "./WorkInteractions.vue?vue&type=script&lang=js"
export * from "./WorkInteractions.vue?vue&type=script&lang=js"

import "./WorkInteractions.vue?vue&type=style&index=0&id=6542f809&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6542f809"]])

export default __exports__